import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { WALLET_CACHE_TAGS } from 'modules/common/constants/cache-tags';
import { PAYMENT_CACHE_TAGS } from 'modules/payments/const';

export const cryptoApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: () => ({}),
  reducerPath: 'cryptoApi',
  tagTypes: [
    ...Object.values(WALLET_CACHE_TAGS),
    ...Object.values(PAYMENT_CACHE_TAGS),
  ],
});
